"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const prompt_1 = require("./prompt");
const source_1 = require("./source");
const styled_components_1 = __importDefault(require("styled-components"));
class BareInput extends React.Component {
    render() {
        if (this.props.hidden) {
            return null;
        }
        return React.createElement("div", { className: this.props.className }, this.props.children);
    }
}
BareInput.defaultProps = {
    children: null,
    hidden: false
};
exports.Input = styled_components_1.default(BareInput) `
  & {
    display: flex;
    flex-direction: row;
  }

  &.invisible {
    height: 34px;
  }

  & ${prompt_1.Prompt} {
    flex: 0 0 auto;
  }

  & ${source_1.Source} {
    flex: 1 1 auto;
    overflow: auto;
    background-color: var(--theme-cell-input-bg, #fafafa);
  }
`;
exports.Input.displayName = "Input";
